import React from "react";

type PanelBaseSide = "left" | "right";

type PanelBaseContextValue = {
	side: PanelBaseSide;
};

const PanelBaseContext = React.createContext<PanelBaseContextValue | null>(null);

const usePanelBaseContext = (): PanelBaseContextValue => {
	const context = React.useContext(PanelBaseContext);
	if (!context) {
		throw new Error("usePanelBaseContext must be used within a PanelBase component");
	}
	return context;
};

export { PanelBaseContext, usePanelBaseContext };
export type { PanelBaseSide };
